import React, { FunctionComponent } from 'react';

import { CSSObject } from '@emotion/core';
import ResponsiveJobCard, { ResponsiveJobCardProps } from '@gojob/ui-bits/ResponsiveJobCard';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export const useWithMediaQuery = (): ((styles: CSSObject) => CSSObject) => {
  const { breakpoint } = useTheme();
  const mediaQuery = breakpoint.up('md');

  return (styles: CSSObject) => ({ [mediaQuery]: styles });
};

const JobCard: FunctionComponent<ResponsiveJobCardProps> = (props) => {
  const { ...other } = props;

  return <ResponsiveJobCard {...other} />;
};

export default JobCard;
